import { useContext } from 'react';
import { UnitJourneyContext } from '@/context/unitJourneyContext';

export const useUnitJourneyContext = () => {
    const context = useContext(UnitJourneyContext);
    if (!context) {
        throw new Error('useUnitJourneyContext must be used within a UnitJourneyContext.Provider');
    }
    return context;
}